import { AfterViewInit, Component, ElementRef, inject, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TradingViewService } from '@zero/shared/charts/ui-charts-base';
import { ModalComponent } from '@zero/shared/ui-web-design-system';
import { DepotChartSerie, Period, StatisticsFacade } from '@zero/statistics/domain';
import { MyChartModel } from '@zero/statistics/feature-statistics/base';

@Component({
  selector: 'statistics-my-expanded-chart-modal',
  templateUrl: './my-expanded-chart-modal.component.html',
  styleUrls: ['./my-expanded-chart-modal.component.scss'],
  imports: [TranslocoPipe, ModalComponent],
})
export class MyExpandedChartModalComponent implements AfterViewInit, OnChanges {
  @Input() public model?: MyChartModel;
  @Input() public chartWithCash: DepotChartSerie[];
  @Input() public chartWithoutCash: DepotChartSerie[];

  readonly #chartService = inject(TradingViewService);
  readonly #activeModal = inject(NgbActiveModal);
  readonly #statisticsFacade = inject(StatisticsFacade);

  @ViewChild('expandedChart', { static: false }) public readonly chart: ElementRef<HTMLDivElement>;

  public ngAfterViewInit(): void {
    this.#chartService.setupMyChart(this.chart.nativeElement);
    this.#init();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    changes['chartWithoutCash']?.currentValue && changes['chartWithCash']?.currentValue && this.#init();
  }

  #init = (): void => this.#chartService.initMyChart(this.chartWithoutCash, this.model?.withCash ? this.chartWithCash : null);

  public close = () => this.#activeModal.close();

  public togglePeriod = (value: number | Period): void => {
    this.model.periods = this.model.periods.map((period) => ({
      ...period,
      isActive: period.value === value,
    }));
    this.#statisticsFacade.changeChartPeriod(value);
  };

  public toggleCash = (withCash: boolean): void => {
    this.model.withCash = withCash;
    this.#chartService.toggleCashLine(this.model.withCash, this.chartWithCash);
  };
}
